import type { AiChatMessage } from "@productlane/lib/src/ai"

import type { CopilotRewritePreview } from "./copilot-rewrite-preview-dialog"
import type { CopilotPageContext } from "./sidebar-ai-chat-sync"

type ContentRewrite = NonNullable<AiChatMessage["contentRewrite"]>

const DEFAULT_ICON = "Page2"
const DEFAULT_TITLE = "Untitled"

// A composer draft has no left-hand side: the copilot writes into a reply
// editor it cannot read back, so there is nothing to diff against.
export function buildRewritePreview({
	rewrite,
	pageContext,
	contextTitle,
	contextIcon,
}: {
	rewrite: ContentRewrite
	pageContext?: CopilotPageContext
	contextTitle?: string
	contextIcon?: string | null
}): CopilotRewritePreview | null {
	if (rewrite.target === "composer") return null
	const baseHtml = pageContext?.html?.trim()
	if (!baseHtml) return null

	return {
		rewrite,
		baseHtml,
		title: pageContext?.title?.trim() || contextTitle?.trim() || DEFAULT_TITLE,
		icon: contextIcon ?? DEFAULT_ICON,
	}
}
